/* globals jQuery, wordpress_globals */

import svgxhr from 'webpack-svgstore-plugin/src/helpers/svgxhr';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Swiper from 'swiper';
import smoothscroll from 'smoothscroll-polyfill';
import ImageSlider from './modules/image_slider';
import cf from './modules/cf';
import Dropdown from './modules/dropdown';
import NewsDropdown from './modules/news-dropdown';
import Masonry from 'masonry-layout';
import Map from './modules/map';
import MainMap from './modules/main_map';
import Accordion from './modules/accordions';
import Header from './modules/header';
import Modals from './modules/modals';
import AnchorBlock from './modules/anchor_block';
import MultiDropdown from './modules/multi_dropdown';
import CTA from './modules/cta'; 
import objectFitImages from 'object-fit-images';

window.namespace = {
	init: function() {
		objectFitImages();
		if(typeof NodeList.prototype.forEach !== 'function'){
			NodeList.prototype.forEach = Array.prototype.forEach;
		}

		smoothscroll.polyfill();

		// let this_y = window.scrollY;
		// window.scrollTo(0, this_y);

		ImageSlider.init();
		cf.init();
		Dropdown.init();
		new NewsDropdown();
		let map = new Map('#map');
		let main_map = new MainMap('#main_map')
		Accordion.init();
		// new WPAjax();
        let news_container = document.getElementById('news-container');
		if(news_container && window.innerWidth > 1199) {
			let gutter = (navigator.userAgent.indexOf('MSIE')!==-1
				|| navigator.appVersion.indexOf('Trident/') > -1) ? 17.5 : 20;

			let anchor_date = new AnchorBlock('.card:not(.large) h3', true, 4);
			let anchor_date_large = new AnchorBlock('.card.large h3', true, 3);

			var grid = new Masonry(news_container, {
				gutter: gutter,
				horizontalOrder: true,
				itemSelector: '.card',
				columnWidth: 295,
			})
		}
		Header.init();
		Modals.init();
		CTA.init();
		
		if(window.innerWidth > 1200) {
			let anchor_date = new AnchorBlock('.card:not(.large) h3', true, 4);
			let anchor_date_large = new AnchorBlock('.card.large h3', true, 3);
		}
		MultiDropdown.init();
		// MailchimpAjax.init();

		let back_to_top = document.getElementById('top');
		if(back_to_top) {
			back_to_top.addEventListener('click', () => {
				$("html, body").animate({ scrollTop: 0 }, "quick");
			})

			back_to_top.addEventListener('keydown', (e) => {
				if(e.keyCode === 13) {
					$("html, body").animate({ scrollTop: 0 }, "quick");
				}
			})
		}

		//getting all video blocks on ie11 and hiding them.
		// if(navigator.userAgent.indexOf('MSIE')!==-1
		// 	|| navigator.appVersion.indexOf('Trident/') > -1) {
		// 	let videos = document.querySelectorAll('.video-block[data-ie11-hide="true"]');
		// 	Array.from(videos).forEach(video => {
		// 		video.style.display="none";
		// 	})
		// }

		//Add standard class to caldera form validation and fix errorContainer to handle class change
		// window.Parsley.on('form:init', form => {
		// 	form.options.errorTemplate = '<span></span>';
		// 	form.options.errorsWrapper = '<span class="form__validation help-block caldera_ajax_error_block"></span>';
		// 	form.options.errorWrapper = '<span></span>';
		// 	form.options.errorsContainer = field => field.$element.closest('.form__group');
		// });

		//Allow user to interrupt auto-scrolling
		$(document).bind('scroll mousedown wheel keyup', function(e) {
			if(e.which || e.type === 'mousedown' || e.type === 'mousewheel') {
				$(document.scrollingElement).stop();
			}
		});
	},

	//Prefer creating new modules when appropriate, rather than adding functions here
	//If you need something to be globally accessible, you can assign an imported module to this namespace
	//I.e import Contact from './contact';
	//    window.namespace.Contact = Contact;
};

window.namespace.init();

// SVG Sprite Loader
// eslint-disable-next-line no-unused-vars
const __sprite__ = {
	path: '../../resources/images/icons/**/*.svg', //Source SVGs path relative to the compiled js (dist/js)
	name: 'images/icons.svg', //Compiled file path relative to dist/
};

svgxhr({
	filename: './wp-content/themes/class/dist/images/icons.svg', //URL to fetch
});
